import { MenuItem } from "@/app/ui/navigation/types";
import { dutySchemeType } from "@/components/pages/duty/composables/dutyConfiguration";
import type { Location } from "vue-router";
import type Guid from "@/app/types/common/guid";
import { LocalDate } from "@js-joda/core";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const dutyMenuEire = {
  root: "navigation_duty_group_eire",
  beerDutyReturn: {
    list: "eire_beer_duty_return_list",
    listLocation: (): Location => ({
      name: dutyMenuEire.beerDutyReturn.list,
    }),
    edit: "eire_beer_duty_return_edit",
    editLocation: (id: Guid, isEditing: boolean): Location => ({
      name: dutyMenuEire.beerDutyReturn.edit,
      params: {
        id: id.toString(),
        mode: isEditing ? "edit" : "view",
      },
    }),
    createLocation: (): Location => ({
      name: dutyMenuEire.beerDutyReturn.edit,
    }),
  },
  stockReturn: {
    list: "eire_stock_return_list",
    listLocation: (): Location => ({
      name: dutyMenuEire.stockReturn.list,
    }),
    edit: "eire_stock_return_edit",
    editLocation: (id: Guid, isEditing: boolean): Location => ({
      name: dutyMenuEire.stockReturn.edit,
      params: {
        id: id.toString(),
        mode: isEditing ? "edit" : "view",
      },
    }),
    createLocation: (): Location => ({
      name: dutyMenuEire.stockReturn.edit,
    }),
  },
  audit: "eire_duty_audit_report",
  viewAudit: (fromDate: LocalDate, toDate: LocalDate): Location => ({
    name: dutyMenuEire.audit,
    params: {
      fromDateInclusive: fromDate.toString(),
      toDateInclusive: toDate.toString(),
    },
  }),
};

export const buildDutyMenuEireItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    name: dutyMenuEire.root,
    icon: "Assignment",
    visible: () =>
      dutySchemeType.value.isEire() &&
      hasPermissionsUsingUserStore([EnumUserPermission.menuDutyView]),
    subMenus: [
      MenuItem.fromOpts({
        name: dutyMenuEire.beerDutyReturn.list,
        url: "/duty/eire/beer-duty-returns-list",
        breadcrumbParentName: dutyMenuEire.root,
        view: () =>
          import(
            /* webpackChunkName: "eire-duty" */ "@/components/pages/duty/eire/ListEireBeerDutyReturn.vue"
          ),
      }),
      MenuItem.fromOpts({
        name: dutyMenuEire.beerDutyReturn.edit,
        url: "/duty/eire/beer-duty-return/:id?/:mode?",
        breadcrumbParentName: dutyMenuEire.beerDutyReturn.list,
        view: () =>
          import(
            /* webpackChunkName: "eire-duty" */ "@/components/pages/duty/eire/EditEireBeerDutyReturn.vue"
          ),
        visible: false,
      }),
      MenuItem.fromOpts({
        name: dutyMenuEire.stockReturn.list,
        url: "/duty/eire/stock-returns-list",
        breadcrumbParentName: dutyMenuEire.root,
        view: () =>
          import(
            /* webpackChunkName: "eire-duty" */ "@/components/pages/duty/eire/ListEireStockReturn.vue"
          ),
      }),
      MenuItem.fromOpts({
        name: dutyMenuEire.stockReturn.edit,
        url: "/duty/eire/stock-return/:id?/:mode?",
        breadcrumbParentName: dutyMenuEire.beerDutyReturn.list,
        view: () =>
          import(
            /* webpackChunkName: "eire-duty" */ "@/components/pages/duty/eire/EditEireStockReturn.vue"
          ),
        visible: false,
      }),
      MenuItem.fromOpts({
        name: dutyMenuEire.audit,
        url: "/duty/eire/audit",
        componentProps: (r) => ({
          fromDateInclusive:
            r.params.fromDateInclusive &&
            LocalDate.parse(r.params.fromDateInclusive),
          toDateInclusive:
            r.params.toDateInclusive &&
            LocalDate.parse(r.params.toDateInclusive),
        }),
        view: () =>
          import(
            /* webpackChunkName: "eire-duty" */ "@/components/pages/duty/eire/DutyAudit.vue"
          ),
      }),
    ],
  }),
];
